import { ModalDirective } from 'ng2-bootstrap/components/modal';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TranslateService } from '../../shared/translate';
import { CostAndExpenseModel } from '../../cost-expenses/models/cost-expense.model';
import { WeGoConfig, DataListModel } from '../../shared/config';
import { FlatPickrModel } from '../../plugins/flatpickr/flatpickr.model';
import { CostAndExpenseService } from '../../cost-expenses/models/cost-expense.service';
import { AuthService } from '../../shared/models/auth.service';
import { InvoiceService } from '../models/invoice.service';
import { BookingService } from '../../booking/models/booking.service';
import { DropdownModel } from '../../report/models/report-filter.model';



@Component({
  selector: 'wego-manual-invoice-line-update-popup',
  template: require('../views/manual-invoice-line-update.component.html'),
  providers: [CostAndExpenseService, InvoiceService, BookingService],
  styles: [`
    .form-horizontal .control-label{
      text-align: left;
    }
  `]
})

export class ManualInvoiceLineUpdatePopupComponent implements OnInit, OnDestroy {
  isEdit: boolean;
  tempVatPer: number;
  errorModel: any[];
  apiErrorMsg: any;
  costTypeList: any;
  _model: CostAndExpenseModel = new CostAndExpenseModel();
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  flatPickrConfigFrom: FlatPickrModel;
  BookingList: DropdownModel[] = [];
  costAndExpenseList: CostAndExpenseModel[] = [];
  DataListModel: DataListModel = new DataListModel();
  vatSettingList: DropdownModel[];
  isNew: boolean = true;
  vatSettingDefaultCost: boolean;
  _selectedExpenseHashIdList: string[];

  @ViewChild("receiptFile") public receiptFile: any;
  @ViewChild('manualInvoiceLineModal') public manualInvoiceLineModal: ModalDirective;

  @Input()
  set model(model: CostAndExpenseModel) {
    this._model = model;
  }
  get model(): CostAndExpenseModel { return this._model; }

  @Input()
  set SelectedExpenseHashIdList(selectedExpenseHashIdList: string[]) {
    this._selectedExpenseHashIdList = selectedExpenseHashIdList;
  }
  get SelectedExpenseHashIdList() { return this._selectedExpenseHashIdList; }
  
  @Output("OnSuccessSelect") OnSuccessSelect = new EventEmitter();
  @Output("OnHidden") OnHidden = new EventEmitter();

  public costAndExpensesList: CostAndExpenseModel[] = [];

  constructor(private translate: TranslateService
    , private costAndExpenseService: CostAndExpenseService
    , private authService: AuthService
    , private invoiceService: InvoiceService
    , private bookingService: BookingService
  ) { }

  ngOnInit() {
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  public GetCostTypeList() {

    //this.tempVatPer = this.model.reportedVatPercentage;

    this.costAndExpenseService
      .GetDropdownCostTypeList("", this.model.recipientDriverHashId, this.model.recipientOrganizationHashId)
      .subscribe(
        res => {
          this.costTypeList = res.data;
          //   this.model.reportedVatPercentage = this.tempVatPer;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetBookingList() {
    this.invoiceService.GetDropdownBookingList(this.model.sharedVehicleGroupDriverHashId, this.model.recipientOrganizationHashId)
      .subscribe(
        res => {
          this.BookingList = res.data;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public show(isEdit: boolean) {
    this.apiErrorMsg = "";
    this.errorModel = [];
    this.manualInvoiceLineModal.show();
    this.model = JSON.parse(JSON.stringify(this.model));

    //let tempModel = JSON.parse(JSON.stringify(this.model));

    this.GetBookingList()
    this.GetCostTypeList();
    this.GetVatSettingDropdownList();

    //this.model = JSON.parse(JSON.stringify(tempModel));;



    this.isEdit = isEdit;
  }

  public hide() {
    this.model = new CostAndExpenseModel();
    this.BookingList = [];
    this.costTypeList = [];
    this.manualInvoiceLineModal.hide();
  }

  private Confirm($event: any) {
    this.hide();
  }

  private OnBookingChange() {
    this.GetVatSettingDropdownList();
  }

  public GetVatSettingDropdownList() {
    if (this.model.bookingHashId) {
      this.bookingService.GetVatSettingDropdownList(this.model.bookingHashId)
        .subscribe(
          res => {
            if (res.data) {
              this.vatSettingList = res.data;
              //this.GetVatSettingDefaultValues();
            }
            else {
              this.apiErrorMsg = res.error;
            }
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    }
  }

  public GetVatSettingDefaultValues() {
    this.bookingService
      .GetVatSettingDefaultValues(this.model.bookingHashId)
      .subscribe(
        res => {
          if (res.data) {
            const vatSettingDefaultValues = res.data;
            this.vatSettingDefaultCost =
              vatSettingDefaultValues.vatSettingDefaultCost;
          } else {
            this.errorModel = res.error;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public onHidden($event:any)
  {
    this.OnHidden.emit();
  }

  public onSubmit() {

    let frmData: FormData = new FormData();

    this.model.reportedByDriver = false;
    let selectedBooking = this.BookingList.find(x => x.keyHash == this.model.bookingHashId);
    if (selectedBooking) {
      this.model.bookingReferenceID = selectedBooking.value;
    }

    if (this.model) {
      frmData.append("manualInvoiceLine", JSON.stringify(this.model));
      this.UploadManualLine(frmData);
    }
  }

  public ClearFileInput() {
    if (this.receiptFile && this.receiptFile.nativeElement) {
      this.receiptFile.nativeElement.value = "";
    }
  }


  public UploadManualLine(formData: FormData) {
    this.invoiceService.UpdateCostAndExpenses(formData, this._model.module).subscribe(
      res => {
        console.log(res);
        if (res.data) {
          this.errorModel = [];
          this.ClearFileInput();


          this.model.approvedVatPercentage = this.model.reportedVatPercentage;
          this.model.reportedVatAmount = (this.model.reportedAmountExVat * this.model.reportedVatPercentage / 100).valueOf();
          this.model.approvedAmountVat = this.model.reportedVatAmount;
          this.model.reportedAmountInVat = Number.parseFloat(this.model.reportedAmountExVat.toString()) + Number.parseFloat(this._model.reportedVatAmount.toString());
          this.model.approvedAmountInVat = this.model.reportedAmountInVat;
          this.model.approvedAmountExVat = this.model.reportedAmountExVat;
          this.model.costAndExpenseHashId = res.data;


          this.OnSuccessSelect.emit({ CostAndExpenseModel: this.model });
          this.hide();

        } else {
          this.errorModel = res.error;
        }
      },
      error => {
        console.log(error);
        this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public SetVatDefaultCost(vatSettingDefaultCost: boolean) {
    return vatSettingDefaultCost
      ? this.translate.instant('LblExcludingVat')
      : this.translate.instant('LblIncludingVat');
  }

  ngOnDestroy() {
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/invoice/components/manual-invoice-line-update.component.ts